<template>
  <el-table-column
    v-bind="$attrs"
    v-on="$listeners"
    :align="this.$attrs.align || 'left'"
  >
    <template slot-scope="{ row }">
      <div class="custom-control custom-checkbox custom-control-no-label">
        <input type="checkbox" class="custom-control-input" disabled :checked="checked.split('.').reduce((obj, key)=> obj[key], row)">
        <label class="custom-control-label"></label>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    props: {
      checked: {
        type: String,
        default: false,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/table-column-checkbox.vue